@let item = document();

<ion-card
  [routerLink]="detailRoute() ? [detailRoute(), item.id] : undefined"
  routerDirection="root"
  routerLinkActive="active"
  [class.is-carrier]="isCarrier()"
  [class.is-shipper]="isShipper()"
  [class.invalid]="isInvalid()"
>
  <!-- TODO check if is invalid in all segments -->
  <ion-card-content>
    <ion-grid
      fixed="true"
      class="ion-no-padding fs-sm"
    >
      <ion-row class="ion-align-items-stretch">
        <ion-col
          size="12"
          size-md="4"
        >
          <div class="with-icon">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/barcode_24dp.svg"
            ></ion-icon>
            <strong>
              {{ item.reference }}
            </strong>
          </div>

          @if (item.segments.length > 1) {
            <div class="with-icon">
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/route_24dp.svg"
              ></ion-icon>
              <span>
                <strong>{{ item.segments.length }}</strong> tramos
              </span>
            </div>
          }

          @if (isCarrier()) {
            <div class="with-icon">
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/box_24dp.svg"
              ></ion-icon>
              <strong>
                {{ item.shipper.companyName }}
              </strong>
            </div>
          }
          @if (isShipper()) {
            <div class="with-icon">
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/local_shipping_24dp.svg"
              ></ion-icon>
              @if (!item.carrier.contactEmail) {
                <strong>
                  <ion-text color="danger">Sin transportista</ion-text>
                </strong>
              } @else {
                <strong>
                  {{ item.carrier.companyName }}
                </strong>
              }
            </div>
          }
          <div class="plates">
            @if (item.tractorPlateNumber) {
              <span class="plate-number">
                {{ item.tractorPlateNumber }}
              </span>
              @if (item.trailerPlateNumber) {
                <span class="plate-number">
                  {{ item.trailerPlateNumber }}
                </span>
              }
            } @else {
              <ion-text color="danger">Sin matrículas</ion-text>
            }
          </div>
        </ion-col>

        <ion-col
          size="6"
          size-md="4"
        >
          <div class="with-icon">
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/date_range_24dp.svg"
            ></ion-icon>
            <span>
              {{ item.segments[0].origin.date | dfnsFormat: 'EE' }}
              <strong>{{ item.segments[0].origin.date | dfnsFormat: 'P' }}</strong>
              {{ item.segments[0].origin.date | dfnsFormat: 'p' }}&nbsp;h
            </span>
          </div>

          <div class="with-icon ion-align-items-start">
            <span>
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/line_start_circle_24dp.svg"
              ></ion-icon>
            </span>
            <div>
              <div>{{ item.segments[0].origin.companyName }}</div>
              <div>
                ({{ item.segments[0].origin.postalCode }}) <strong>{{ item.segments[0].origin.city }}</strong
                >,
                {{ 'states.' + item.segments[0].origin.countryCode + item.segments[0].origin.stateCode | translate }}
              </div>
            </div>
          </div>
        </ion-col>

        <ion-col
          size="6"
          size-md="4"
        >
          @if (item.segments[item.segments.length - 1].destination.date) {
            <span class="with-icon">
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/date_range_24dp.svg"
              ></ion-icon>
              <span>
                {{ item.segments[item.segments.length - 1].destination.date | dfnsFormat: 'EE' }}
                <strong>{{ item.segments[item.segments.length - 1].destination.date | dfnsFormat: 'P' }}</strong>
                {{ item.segments[item.segments.length - 1].destination.date | dfnsFormat: 'p' }}&nbsp;h
              </span>
            </span>
          }
          <div class="with-icon ion-align-items-start">
            <span>
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/line_end_square_24dp.svg"
              ></ion-icon>
            </span>
            <div>
              <div>{{ item.segments[item.segments.length - 1].destination.companyName }}</div>
              <div>
                ({{ item.segments[item.segments.length - 1].destination.postalCode }})
                <strong>{{ item.segments[item.segments.length - 1].destination.city }}</strong
                >,
                {{
                  'states.' +
                    item.segments[item.segments.length - 1].destination.countryCode +
                    item.segments[item.segments.length - 1].destination.stateCode | translate
                }}
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
